import { type GlobalStorageFile } from 'hb-react/shared/hooks/useGlobalStorageV2/types';
import { buildMagicKeyUrls } from 'hb-react/shared/hooks/useGlobalStorageV2/utils/buildMagicKeyUrls';

export const isContentHtmlEmpty = (contentHtml) => {
  // Content undefined or empty string
  if (!contentHtml) {
    return true;
  }

  // Images count as content even if no text is present
  if (
    contentHtml.includes('<img') ||
    contentHtml.includes('class="embedly-embed"')
  ) {
    return false;
  }

  // Remove all HTML tags and see if there is any text left
  if (contentHtml.replace(/<(.|\n)*?>/g, '').trim().length > 0) {
    return false;
  }

  return true;
};

export const preProcessContentHtml = ({
  quillRef,
  uploadsFieldName,
  files = [],
}: {
  files: Array<GlobalStorageFile>;
  quillRef;
  uploadsFieldName: string;
}) => {
  if (files.some(({ id, shrineKey }) => !id && !shrineKey)) {
    throw new Error('GlobalStorageFiles must have an id or a shrineKey');
  }

  if (!quillRef.current) {
    throw new Error('Quill ref is not defined');
  }

  const html = quillRef.current.root.innerHTML;

  // No need to process images if there are no base64 images
  if (!html.includes('base64')) {
    return html;
  }

  const urls = buildMagicKeyUrls(files, uploadsFieldName);

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const images = doc.querySelectorAll('img');

  images.forEach((image) => {
    const id = image.getAttribute('id');

    if (id && urls[id]) {
      image.setAttribute('src', urls[id]);
    }
  });

  const contentHtml = doc.body.innerHTML;

  return contentHtml;
};
